import CRUDTableComponent from '../../components/CRUDTableComponent'

const ProfessionsTable = () => {
  const tableColumns = [
    {
      title: 'ID',
      dataIndex: 'id',
    },
    {
      title: 'Nombre',
      dataIndex: 'name',
      type: 'string',
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
  ]

  return (
    <CRUDTableComponent
      entityName={{ plural: 'Profesiones', singular: 'Profesión' }}
      tableColumns={tableColumns}
      entityUrl="/professions?sortBy=name"
    />
  )
}

export default ProfessionsTable
